module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	var _ = {
		Translation: {
			alias: null,
			defaultVal: null,
			context: null,
			toString: function() {
				if (typeof(fox) != "undefined" && fox.i18n) {
					return fox.i18n._getTranslation(this.alias, this.defaultVal, this.context);
				}
				return this.defaultVal;
			}
		},

		getTranslationObject: function(alias, defaultVal, context) {
			return fox.merge(fox.clone(this.Translation), {alias: alias, defaultVal: defaultVal, context: context});
		}
	};

	fox.registerWidget('Dictionary', {
		configure: function() {
			this.registerOptions('', {
				method: 'dictionary.load',
				useCdn: false
			});

			this.defaultLang = 'en';
			this.phrases = {};
			this.phrases[this.defaultLang] = {};
			this.loadedDics = {};
			this.promises = {};

			this.callParent('configure', arguments);
		},

		init: function() {

			fox.i18n || Object.defineProperty(fox, 'i18n', {
				get: function() {return fox.site.rwom1('.Dictionary')}
			});

			if (fox.cookie.get('dic') === 'interim') {
				this.setOption('method', 'dictionary.loadInterim');
			}

			if (fox.cookie.get('i18n-domain')) {
				this.setOption('domain', 'https://' + fox.cookie.get('i18n-domain'));
			}

			if (!fox.isEmpty(this.getOption('dic'))) {
				this.root = this.rwom1('@root');
				this.rootAfterEmbed = this.root.afterEmbed;
				this.rootAfterEmbedCaught = 0;
				this.root.afterEmbed = function() {
					this.rootAfterEmbedCaught = 1;
				}.bind(this);
				setTimeout(function() {
					this._allowRootRender && this._allowRootRender()
				}.bind(this), 5000);
			}

			this.callParent('init', arguments);
		},

		setLang: function(lang) {
			if (this.lang === lang) {
				return;
			}
			this.lang = lang;
			var alias = this.getOption('dic');
			var interim = fox.cookie.get('dic') == 'interim';
			var useCdn = this.getOption('useCdn');
			var promises = [];

			if (!interim && useCdn) {
				this._loadDics(alias, this.lang, promises).then(function() {
					delete this.promises[lang];
				}.bind(this));
			} else {
				if (fox.isArray(alias)) {
					fox.each(alias, function(alias) {
						promises.push(this._loadDic(alias, this.lang));
					}, this);
				} else {
					promises.push(this._loadDic(alias, this.lang));
				}

				this._applyTranslations(promises);
			}
		},

		_applyTranslations: function(promises) {
			fox.RSVP.all(promises).then(function() {
				this.dispatchEvent('loaded');
				this._commit();
				this._allowRootRender && this._allowRootRender();
			}.bind(this));
		},

		_allowRootRender: function() {
			if (!this.rootAfterEmbedCaught) {
				return;
			}
			console.log('allow');
			this.root.afterEmbed = this.rootAfterEmbed;
			if (this.rootAfterEmbedCaught) {
				this.root.afterEmbed();
				this.rootAfterEmbedCaught = 0;
			}
			delete this._allowRootRender;
		},

		_loadDic: function(alias, lang) {
			if (this.promises[alias + '_' + lang]) {
				return this.promises[alias + '_' + lang];
			}
			this.promises[alias + '_' + lang] = new fox.RSVP.Promise(function (resolve, reject) {
				if (lang == this.defaultLang || this.loadedDics[alias + '_' + lang]) {
					return resolve();
				}
				this.loadedDics[alias + '_' + lang] = 1;
				var url = this.getOption('domain') + '/api/' + this.getOption('method');
				fox.requestApi(url, {alias:alias, lang:lang}).then(function (response) {					
					this._parseDictionary(response, lang);
					this.loadedDics[alias + '_' + lang] = 1;
					delete this.promises[alias + '_' + lang];
					resolve();
				}.bind(this)).catch(function(resp) {
					console.error(resp);
				});
			}.bind(this));
			return this.promises[alias + '_' + lang];
		},

		_parseDictionary: function(dictionary, lang) {
			var dict = JSON.parse(dictionary);
			if (!fox.isEmpty(dict)) {
				this.phrases[lang] = fox.mergeRecursive(this.phrases[lang] || {}, dict);
			}
		},

		_loadDics: function(aliases, lang, promises) {
			if (this.promises[lang]) {
				return this.promises[lang];
			}

			this.promises[lang] = new fox.RSVP.Promise(function (resolve) {
				if (lang == this.defaultLang || this.loadedDics[lang]) {
					this._applyTranslations([]);
					return resolve();
				}
				var url = this.getOption('domain') + '/api/dictionary.getUrls';

				fox.requestApi(url, {alias: aliases, lang: lang}).then(function (response) {					
					var urls = JSON.parse(response);
					fox.each(urls, function(url, alias) {
						promises.push(this._loadCdnDic(url, lang));
					}, this);

					this._applyTranslations(promises);
					this.loadedDics[lang] = 1;
					resolve();
				}.bind(this)).catch(function(resp) {
					console.error(resp);
				});	
			}.bind(this));
			return this.promises[lang];
		},

		_loadCdnDic: function(url, lang) {
			return new fox.RSVP.Promise(function(resolve) {
				fox.requestApi(url, []).then(function (response) {
						this._parseDictionary(response, lang);
						resolve();
				}.bind(this)).catch(function(resp) {
					console.error(resp);
				});		
			}.bind(this));
		},

		_updateNode: function(node) {
			var alias = node.getAttribute('data-fox-alias');
			var context = node.getAttribute('data-fox-context') || 'default';

			if (!this.phrases[this.lang] || !this.phrases[this.lang][context] || !this.phrases[this.lang][context][alias]) {
				return false;
			}
			if (!this.phrases[this.defaultLang][context]) {
				this.phrases[this.defaultLang][context] = {};
			}
			if (!this.phrases[this.defaultLang][context][alias]) {
				this.phrases[this.defaultLang][context][alias] = {};
			}

			fox.each(this.phrases[this.lang][context][alias], function(value,attr) {
				if (value) {
					var oldVal = '';
					if (attr === 'text') {
						oldVal = node.innerHTML;
						node.innerHTML = value;
					} else {
						oldVal = node.getAttribute(attr);
						node.setAttribute(attr,value);
					}

					if (!this.phrases[this.defaultLang][context][alias][attr]) {
						this.phrases[this.defaultLang][context][alias][attr] = oldVal;
					}
				}				
			}, this);
			
			return true;
		},

		_commit: function() {
			if (!this.phrases[this.lang]) {
				return;
			}
			if (!this.handlerExists) {
				this.handlerExists = true;
				var dic = this;
				this.getEm().handleHook('~.Widget', 'onStartEmbedToDom', function() {
					fox.each(this.dom('[data-fox-alias]'), dic._updateNode, dic);
					if (fox.Navigator) {
						fox.Navigator.addClickHandler(this.getMyNodes());
						this.setDomHandlers();
					}
				}, {prefix: '_dictionary_'});
			}
			fox.site.afterEmbed();
		},
		getTranslation: function(alias,defaultVal,context) {	
			if (!alias && !defaultVal) {
				return '';
			}
			return _.getTranslationObject(alias, defaultVal, context);
		},

		getISOLang: function(alias,defaultVal,context) {	
			if (!this.lang) {
				return this.defaultLang;
			} else if (this.lang === 'sp') {
				return 'es';
			}
			return this.lang;
		},

		_getTranslation: function(alias,defaultVal,context) {
			context = context || 'js';
			if (!this.lang || this.lang === this.defaultLang || !this.phrases[this.lang] || !this.phrases[this.lang][context] || !this.phrases[this.lang][context][alias]) {
				return defaultVal;
			}

			return this.phrases[this.lang][context][alias].text || defaultVal;
		}

	}, 'Controller');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/dictionary.js
// module id = 187
// module chunks = 0